module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAABbElEQVRIibXUO0scURjG8Z+LbGltxCIECxsR0qUS7KIWQRtrQfBGmnQ29ukthiCpRMEQxQ9goZAPELEKBG/gWiRgFIvNihYzwYnMnB115oEp3suc/5znvGc6oigawSf0qEaHmKkhqhACL/G5ht42jX9LgL2oBYoRulHHIHafQ8oDbWAG50n8HW/FfpcKWsnIXWO94LpHOCgCuszJXxWAROjzwO480FhGrgOjbSCrmEULN/jWDvQBk6m4jo94E4DsYAq3WcXOnJfqWMMSTjAgnsA87WMczbyGPNA/9SdPSKcYwUWoKXSPiugigZy2awyBGpjAsmzfm2K79ot8UQg0h69YwDv8StVuxQe/UwQSAq1iMxVv4zX2kngx6SmsrGFo4H1G/hjD4t19eQyE7B3N4XdOf+spkCzQuv8tK01pUAPzVUAegkKWlQb6g62qINxPXZf4kH+UvP5QGvQTr8S3vCqd1TCtwL/qGTrH9B2POUXSXT8GnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huidan.png
// module id = WTf6
// module chunks = 2